module.exports = __webpack_public_path__ + "img/RIC-alt.7c3f8144.svg";